<template>
   <div>
     <b-row v-if="loadingData">
      <b-col>
        <spinner style="margin-top: 20px;"></spinner>
      </b-col>
    </b-row>
    <b-row v-else-if="nothingAvailable">
      <b-col>
        <h4>Nada Encontrado</h4>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col sm="12">
        <b-card v-if="items && items.length > 0 && !loadingData" :header="caption">
          <b-table
            :dark="dark"
            hover
            striped
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            responsive="sm"
            :items="items"
            :fields="captions"
            :current-page="currentPage"
            :per-page="perPage"
            ref="tableSleekers"
          >
            <template #cell(review)="data">
              
              <b-button v-if="!data.item.inReview" variant="danger" @click="reviewSleeker(data.item)">
                Review
              </b-button>
              <b-badge variant="danger" v-if="data.item.inReview"> Em review </b-badge>
            </template>
            <template #cell(thumbnail)="data">
              <div><img :src="data.item.thumbnail"/></div>
            </template>
            <template #cell(id)="data">
              <div>{{data.item._id}}</div>
            </template>
            <template #cell(creationDate)="data">
              <!-- <b-button size="sm" @click="showDetails(data.item._id)"> -->
              <a v-bind:href="'/admin/creation/update/' + data.item._id" target="_blank">
                <div>{{data.item.creationDate | moment("DD/MM/YYYY HH:mm")}}</div>
              </a>
              <!-- </b-button> -->
            </template>
            <template #cell(access)="data">
              <a v-bind:href="'/design/preview/' + data.item._id" target="_blank">
                <div>Acessar</div>
              </a>
            </template>
            <template #cell(approve)="data">
              <b-button v-if="!data.item.approved" :variant="!data.item.inReview ? 'success' : 'warning'" @click="approveSleeker(data.item)">
                Aprovar
              </b-button>
              {{data.item.approved ? "Aprovado" : ""}}
            </template>
          </b-table>
          <nav>
            <b-pagination
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Anterior"
              next-text="Próxima"
              hide-goto-end-buttons
            />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import service from "../service";
import Spinner from "./Spinner";

export default {
  name: "SleekerList",
  inheritAttrs: false,
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    perPage: {
      type: Number,
      default: 20
    },
    dark: {
      type: Boolean,
      default: false
    },
    whitelabel: false,
    filter: 0,
    sleekers: undefined,
    filterRequester: 0,
    filterController: 0
  },
  data: () => {
    return {
      currentPage: 1,
      emailSearch: undefined,
      phoneSearch: undefined,
      nameSearch: undefined,
      accountType: undefined,
      subscriptionStatus: undefined,
      nothingAvailable: false,
      userDetails: [],
      loadingData: false,
      info: {},
      caption: ""
    };
  },
  computed: {
    items: function() {
      let result = this.sleekers;

      return result;
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    },
    fields: function() {
      let baseFields = [
        {
          label: "Em Review",
          sortable: false,
          key: "review"
        },
        {
          label: "Imagem",
          sortable: false,
          key: "thumbnail"
        },
        {
          label: "ID",
          sortable: true,
          key: "id"
        },
        {
          label: "Data de Criação",
          sortable: true,
          key: "creationDate"
        },
        {
          label: "Acessar",
          sortable: false,
          key: "access"
        },
        {
          label: "Aprovar",
          sortable: false,
          key: "approve"
        }
      ]

      return baseFields;
    }
  },
  methods: {
    getRowCount: function() {
      return this.items.length;
    },
    approveSleeker: function(sleeker) {
      service.approveSleeker(sleeker._id).then(() => {
        sleeker.approved = true;      });
    },
    reviewSleeker: function(sleeker) {
      service.reviewSleeker(sleeker._id).then(() => {
        sleeker.inReview = true;
      });
    }
  },
  components: { Spinner },
  created() {
    
  }
};
</script>


